import React from 'react'
// context
import { ActionContext } from 'context/index'
// constants
import { ENTITIES } from 'constants/index'
// view components
import ReviewsListContainer from 'containers/Review/ReviewList'

const ActionReviewsList: React.FC = () => {
  const { entity } = React.useContext(ActionContext) as any

  const {
    actionCreateScheduledReview,
    actionDeleteScheduledReview,
    actionModifyScheduledReview,
    actionViewCompletedReview,
    actionViewInProgressReview
  } = entity.currentPermissions

  return (
    <ReviewsListContainer
      canCreate={actionCreateScheduledReview}
      canDelete={actionDeleteScheduledReview}
      canModify={actionModifyScheduledReview}
      canViewCompleted={actionViewCompletedReview}
      canViewInProgress={actionViewInProgressReview}
      entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION }}
    />
  )
}

export default ActionReviewsList
